import { Reveal } from "@/components/Reveal";
import { WhatsAppIcon } from "@/components/WhatsAppIcon";
import { waLink } from "@/lib/whatsapp";

const FinalCTA = () => (
    <section id="contato" data-testid="final-cta-section" className="relative bg-[#0A0A0A] overflow-hidden">
        <img
            src="https://images.unsplash.com/photo-1748260526938-4fa5472eb796?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920"
            alt="Pista de dança em evento LC Production"
            loading="lazy"
            className="absolute inset-0 w-full h-full object-cover opacity-20"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0A0A0A] via-[#0A0A0A]/75 to-[#0A0A0A]" />

        <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 py-32 md:py-48">
            <Reveal>
                <p className="text-[10px] tracking-[0.45em] uppercase text-[#E8D5C3]/70 mb-8" data-testid="final-cta-label">
                    Vamos conversar
                </p>
            </Reveal>
            <Reveal delay={0.1}>
                <h2 className="text-4xl sm:text-5xl lg:text-7xl font-extrabold uppercase leading-[0.95] tracking-tight max-w-4xl text-white" data-testid="final-cta-headline">
                    Seu evento merece ser mais do que{" "}
                    <span className="font-editorial italic font-light normal-case text-white">
                        inesquecível.
                    </span>
                </h2>
            </Reveal>
            <Reveal delay={0.2}>
                <p className="mt-8 max-w-xl text-sm md:text-lg text-white/60 leading-relaxed" data-testid="final-cta-text">
                    Conte para nossa equipe o que você está planejando e descubra como a LC Production
                    pode transformar sua ideia em uma experiência completa.
                </p>
            </Reveal>
            <Reveal delay={0.3}>
                <a
                    href={waLink("geral")}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="final-cta-whatsapp"
                    className="mt-12 inline-flex items-center gap-4 bg-[#6A2022] text-white px-10 md:px-14 py-5 md:py-7 text-xs md:text-sm tracking-[0.3em] uppercase font-bold transition-colors duration-300 hover:bg-[#7d282b]"
                >
                    <WhatsAppIcon className="w-5 h-5 md:w-6 md:h-6" />
                    Falar com a LC no WhatsApp
                </a>
            </Reveal>
        </div>
    </section>
);

export default FinalCTA;
